export default __webpack_public_path__ + "static/media/notFound.d128c5b8.png";